<template>
	<div class="configurator__icon-container">
		<svg
			v-if="clock"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12 7V12L15 15M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round" />
		</svg>
		<svg
			v-if="dashboard"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.45 11.5502L15.5 9.50015M10 13.0002C10 13.5306 10.2107 14.0393 10.5858 14.4144C10.9609 14.7894 11.4696 15.0002 12 15.0002C12.5304 15.0002 13.0391 14.7894 13.4142 14.4144C13.7893 14.0393 14 13.5306 14 13.0002C14 12.4697 13.7893 11.961 13.4142 11.5859C13.0391 11.2109 12.5304 11.0002 12 11.0002C11.4696 11.0002 10.9609 11.2109 10.5858 11.5859C10.2107 11.961 10 12.4697 10 13.0002ZM6.4 20.0002C4.93815 18.8382 3.87391 17.2504 3.35478 15.4566C2.83564 13.6629 2.88732 11.752 3.50265 9.98896C4.11797 8.22588 5.26647 6.69786 6.78899 5.61665C8.3115 4.53544 10.1326 3.95459 12 3.95459C13.8674 3.95459 15.6885 4.53544 17.211 5.61665C18.7335 6.69786 19.882 8.22588 20.4974 9.98896C21.1127 11.752 21.1644 13.6629 20.6452 15.4566C20.1261 17.2504 19.0619 18.8382 17.6 20.0002H6.4Z"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round" />
		</svg>
		<svg
			v-if="digitalprint"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M17 17H19C19.5304 17 20.0391 16.7893 20.4142 16.4142C20.7893 16.0391 21 15.5304 21 15V11C21 10.4696 20.7893 9.96086 20.4142 9.58579C20.0391 9.21071 19.5304 9 19 9H5C4.46957 9 3.96086 9.21071 3.58579 9.58579C3.21071 9.96086 3 10.4696 3 11V15C3 15.5304 3.21071 16.0391 3.58579 16.4142C3.96086 16.7893 4.46957 17 5 17H7M17 9V5C17 4.46957 16.7893 3.96086 16.4142 3.58579C16.0391 3.21071 15.5304 3 15 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V9M7 15C7 14.4696 7.21071 13.9609 7.58579 13.5858C7.96086 13.2107 8.46957 13 9 13H15C15.5304 13 16.0391 13.2107 16.4142 13.5858C16.7893 13.9609 17 14.4696 17 15V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H9C8.46957 21 7.96086 20.7893 7.58579 20.4142C7.21071 20.0391 7 19.5304 7 19V15Z"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round" />
		</svg>
		<svg
			v-if="offset"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.5022 19.4228C10.1042 21.5278 13.8972 21.5278 16.4982 19.4228C19.1002 17.3178 19.7602 13.7148 18.0642 10.8768L13.1742 3.61678C12.7542 2.99178 11.8872 2.81378 11.2382 3.21978C11.0753 3.32201 10.9356 3.45725 10.8282 3.61678L5.9352 10.8768C4.2402 13.7148 4.9002 17.3178 7.5022 19.4228Z"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round" />
		</svg>
		<svg
			v-if="file"
			width="24"
			height="25"
			viewBox="0 0 24 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14 3.80469V7.80469C14 8.0699 14.1054 8.32426 14.2929 8.51179C14.4804 8.69933 14.7348 8.80469 15 8.80469H19M14 3.80469H7C6.46957 3.80469 5.96086 4.0154 5.58579 4.39047C5.21071 4.76555 5 5.27425 5 5.80469V19.8047C5 20.3351 5.21071 20.8438 5.58579 21.2189C5.96086 21.594 6.46957 21.8047 7 21.8047H17C17.5304 21.8047 18.0391 21.594 18.4142 21.2189C18.7893 20.8438 19 20.3351 19 19.8047V8.80469M14 3.80469L19 8.80469"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round" />
		</svg>
		<svg
			v-if="upload"
			width="24"
			height="25"
			viewBox="0 0 24 25"
			fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4 17.8047V19.8047C4 20.3351 4.21071 20.8438 4.58579 21.2189C4.96086 21.594 5.46957 21.8047 6 21.8047H18C18.5304 21.8047 19.0391 21.594 19.4142 21.2189C19.7893 20.8438 20 20.3351 20 19.8047V17.8047M7 9.80469L12 4.80469M12 4.80469L17 9.80469M12 4.80469V16.8047"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round" />
		</svg>
	</div>
</template>
<script>

export default {
	name: "Icons",
	data () {
		return {
			valid: false,
			timeout: null
		};
	},
	props: {
		clock: {
			type: Boolean,
			default: false
		},
		dashboard: {
			type: Boolean,
			default: false
		},
		digitalprint: {
			type: Boolean,
			default: false
		},
		offset: {
			type: Boolean,
			default: false
		},
		file: {
			type: Boolean,
			default: false
		},
		upload: {
			type: Boolean,
			default: false
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/element/icons.vue